<ng-template #surgePriceModal let-modal>
    <div class="modal-content">
      <div class="modal-body">
        <div class="m-3">
          <div class="referral">
            <h4 class="mb-3">{{ "heading-title.heading_surge_pricing" | translate : { _VALUE: surgeUnit } }}</h4>
            <p class="text-muted mb-3">
              {{ "label-title.surge-price-description" | translate }}
            </p>
          </div>
          <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
            <button type="button" class="btn w-sm btn-secondary" (click)="onSubmit(true)">{{ "button-title.confirm" | translate }}</button>
            <button type="button" class="btn w-sm btn-outline-secondary" (click)="onSubmit(false)">{{ "button-title.cancel" | translate }}</button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  